import { Grid } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridStyledTagline = styling(Grid)((props) => ({
  display: "flex",
  height: "unset",
  padding: "80px 120px",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "32px",
  alignSelf: "stretch",
  // backgroundImage: props.backgroundImage
  //   ? ` linear-gradient(to right, white 0, transparent 100px, transparent calc(100% - 100px), white 100%),
  // url(${props.backgroundImage}) `
  //   : `
  //   radial-gradient(157.4% 100.15% at 18.33% 0%, rgba(255,255,255,0.2) 25.73%, rgba(81,42,204,0.2) 58.17%, rgba(255,255,255,0.2) 100%),
  //   #FFF
  // `,
  // backgroundBlendMode: "overlay",
  backgroundImage: props.backgroundImage
    ? ` url(${props.backgroundImage}) `
    : `
    radial-gradient(157.4% 100.15% at 18.33% 0%, rgba(255,255,255,0.2) 25.73%, rgba(81,42,204,0.2) 58.17%, rgba(255,255,255,0.2) 100%),
    #FFF
  `,
  backgroundSize: "cover",
  backgroundPosition: "center 35%",
  backgroundRepeat: "no-repeat",
  minHeight: "400px",
  maxWidth: "1500px",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    height: "100%",
    maxHeight: "300px",
    minHeight: "300px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    alignItems: "flex-start",
    maxHeight: "170px",
    minHeight: "170px",
  },
}));
